<template>
  <v-content>
    <v-container fluid style="position: relative">

      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <Header :title="'Company settings'"  />
              <v-card-text>
                  <v-form id="form" ref="form">
                    <v-row>
                        <v-col cols="12" sm="8" md="8">
                            <v-row v-if="errors.length >0">
                                <v-col cols="12" sm="12" md="12">
                                <v-alert
                                    dense
                                    v-for="(v, k) in errors"
                                    :key="k"
                                    outlined
                                    type="error"
                                >{{ k }} {{ v }}</v-alert>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-text-field
                                        :label=" 'Company color' | translate"
                                        name="primarycolor"
                                        autocomplete="off"
                                        :rules="primaryColorRules"
                                        v-model="primarycolor"
                                        outlined
                                        required
                                    >
                                        <template #message="{ message }">
                                          {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                        </template>  
                                        <template v-slot:append>
                                        <v-menu
                                            v-model="menu"
                                            top
                                            nudge-bottom="105"
                                            nudge-left="16"
                                            :close-on-content-click="false"
                                        >
                                            <template v-slot:activator="{ on }">
                                            <div :style="swatchStyle" v-on="on" />
                                            </template>
                                            <v-card>
                                            <v-card-text class="pa-0">
                                                <v-color-picker v-model="primarycolor" flat />
                                            </v-card-text>
                                            </v-card>
                                        </v-menu>
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="12">
                                <v-text-field
                                    outlined
                                    :label="'Session login time' | translate"
                                    v-model="session_log_in_min"
                                    name="session_log_in_min"
                                    :rules="sessionminRules"
                                    autocomplete="off"
                                    type="number"
                                    required
                                >
                                <template #message="{ message }">
                                  {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>  
                                </v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="12">
                                  <v-autocomplete
                                    v-model="timezone"
                                    :items="timezoneList"
                                    item-value="value"
                                    item-text="text"
                                    :label="'Select TimeZone' | translate"
                                    outlined
                                    chips
                                    small-chips
                                    required
                                    :rules="timezoneRules"
                                    :no-data-text="$t('No data available')"
                                  >
                                  <template #message="{ message }">
                                  {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                  </template>
                                  </v-autocomplete>
                                </v-col>
                            </v-row>

                            <h3>{{"Daily Quiz Settings" | translate}}</h3>
                            <v-row>
                              <v-col cols="12" sm="12">
                              <v-text-field
                                  outlined
                                  :label="'Number of Questions' | translate"
                                  v-model="daily_quiz_question_count"
                                  name="daily_quiz_question_count"
                                  autocomplete="off"
                                  type="number"
                                  :rules="dailyQuizQuestionCountRules"
                              >
                              <template #message="{ message }">
                                {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                              </template>  
                              </v-text-field>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="12" sm="12">
                              <v-text-field
                                  outlined
                                  :label="'Passing Percentage' | translate"
                                  v-model="daily_quiz_passing_percent"
                                  name="daily_quiz_passing_percent"
                                  autocomplete="off"
                                  type="number"
                                  append-outer-icon="mdi-percent"
                                  :rules="dailyQuizQuestionPassingRules"
                              >
                              <template #message="{ message }">
                                {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                              </template>  
                              </v-text-field>
                              </v-col>
                            </v-row>

                            <h3>{{"Scheduled Downtime" | translate}}</h3>
                            <v-row>
                              <v-col cols="12" sm="12">
                                <v-checkbox
                                  :label="'Schedule Downtime?' | translate"
                                  v-model="scheduled_downtime" 
                                  name="scheduled_downtime"
                                  >
                                  <template #message="{ message }">
                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                  </template>   

                                </v-checkbox>
                              </v-col>
                          </v-row>
                            <v-row v-if="scheduled_downtime">
                              <v-col cols="6" sm="6">
                                <v-menu
                                  ref="menu"
                                  v-model="menu"
                                  :close-on-content-click="true"

                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      outlined
                                      :label="'Start date' | translate"
                                      v-model="start_date"
                                      name="start_date"
                                      :rules="dateRules"
                                      autocomplete="off"
                                      required
                                      prepend-icon="mdi-calendar"
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                    <template #message="{ message }">
                                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                    </template>
                                    </v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="start_date"
                                    no-title
                                    scrollable
                                    :locale="curLanguage.lang_code"
                                    @input="menu=false"
                                  >
                                  </v-date-picker>
                                </v-menu> 
                              </v-col>

                              <v-col cols="6" sm="6">
                                <v-menu
                                  ref="menu"
                                  v-model="menu"
                                  :close-on-content-click="true"

                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      outlined
                                      :label="'End date' | translate"
                                      v-model="end_date"
                                      name="end_date"
                                      :rules="dateRules"
                                      autocomplete="off"
                                      required
                                      prepend-icon="mdi-calendar"
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                    <template #message="{ message }">
                                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                    </template>
                                    </v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="end_date"
                                    no-title
                                    scrollable
                                    :locale="curLanguage.lang_code"
                                    @input="menu=false"
                                  >
                                  </v-date-picker>
                                </v-menu> 
                              </v-col>

                          
                            </v-row>

                        </v-col>
                        <v-col cols="12" sm="4" md="4"></v-col>
                    </v-row>
                  </v-form>
                    <v-btn
                    dark
                    fab
                    fixed
                    bottom
                    right
                    large
                    color="pink"
                    class="mx-2"
                    @click="update()"
                    >
                    <v-icon>mdi-content-save</v-icon>
                    </v-btn>


              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>
<script>
import {
  RESET_STATE,
  FETCH_COMPANY_SETTINGS,
  UPDATE_COMPANY_SETTINGS,
  CHECK_AUTH
} from "@/store/actions.type";
import {  SET_SNACKBAR,SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
import store from "@/store"
import { mapState } from "vuex"
import { mapGetters } from "vuex"

export default {
    name:"Settings",
    async beforeRouteUpdate(to, from, next) {
        await store.dispatch(RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        await store.dispatch(FETCH_COMPANY_SETTINGS, 'profile');
        store.commit(SET_ROUTER_ENTER, false)
        return next();
    },
    async beforeRouteLeave(to, from, next) {
        await store.dispatch(RESET_STATE);
        next();
    },
    computed: {
        ...mapGetters(['companysettings','currentUser','curLanguage']),
        ...mapState({
        errors: state => state.companysettings.companysettingerrors
        }),
      swatchStyle() {
        const { primarycolor, menu } = this;
        return {
          backgroundColor: primarycolor,
          cursor: "pointer",
          height: "30px",
          width: "30px",
          borderRadius: menu ? "50%" : "4px",
          transition: "border-radius 200ms ease-in-out"
        };
      },
      primaryColorRules(){ return [v => !!v || "Primary color is required"]},
      sessionminRules(){ return [v => !!v || "Session minutes is required"]},
      timezoneRules(){ return [v => !!v || "Please Select Timezone for the Company"]},
      dailyQuizQuestionCountRules(){return [
            v => !(v < 0) || "Please Add Valid Question Count",
      ]},
      dailyQuizQuestionPassingRules(){return [
            v => !(v < 0) || "Please Add Valid Passing Percentage",
      ]},
      timezoneList(){
        // http://worldtimeapi.org/api/timezone
        return [
            {value: 'America/Chicago', text:this.$t('America/Chicago')},
            {value: 'Europe/Berlin', text:this.$t('Europe/Berlin')},
            {value: 'Asia/Kolkata', text:this.$t('Asia/Kolkata')}
        ]
      },
    },
    created (){
        if(this.currentUser.roles.includes(1) == false){
            this.$router.push("/dashboard");
        }
    },
    mounted (){
        if(this.companysettings.hasOwnProperty('setting_data')){
         this.primarycolor   =   this.companysettings.setting_data.primary_color
         this.session_log_in_min = this.companysettings.setting_data.session_log_in_min
         this.timezone = this.companysettings.setting_data.timezone
         this.daily_quiz_question_count = this.companysettings.setting_data.daily_quiz_question_count
         this.daily_quiz_passing_percent = this.companysettings.setting_data.daily_quiz_passing_percent
        }
    },
    data: function() {
        return {
            primarycolor: "#1976D2FF",
            session_log_in_min:'',
            menu: false,
            timezone:null,
            daily_quiz_question_count:'',
            daily_quiz_passing_percent:'',
            scheduled_downtime:false
        }
    },
    components: {
      Header: () => import("@/components/header/Header"),
    },
    methods: {
        update(){
            if (this.$refs.form.validate()) {
        this.$store
          .dispatch(UPDATE_COMPANY_SETTINGS, {
            primary_color: this.primarycolor,
            session_log_in_min: this.session_log_in_min,
            timezone:this.timezone,
            daily_quiz_question_count: this.daily_quiz_question_count,
            daily_quiz_passing_percent: this.daily_quiz_passing_percent
          })
          .then(resp => {
            if (resp !=undefined && resp.hasOwnProperty('success') && resp.success) {
              store.dispatch(CHECK_AUTH).then( resp =>{
                if(resp !== undefined && resp.hasOwnProperty('success') && resp.success == true){
                  store.commit(SET_LOADING, false)
                  store.commit(SET_SNACKBAR, {status: true, message: 'Company settings updated successfully'})
                }
              })
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
            }
        }
    }
}
</script>